import { render, staticRenderFns } from "./RomaUnit.vue?vue&type=template&id=5e9c06ef"
import script from "./RomaUnit.vue?vue&type=script&lang=ts"
export * from "./RomaUnit.vue?vue&type=script&lang=ts"
import style0 from "./RomaUnit.vue?vue&type=style&index=0&id=5e9c06ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports